/* Общий для раздела «Оборудование» и сверки с NetBox (NetboxReconcile) */

.page {
  flex: 1;
  overflow-y: auto;
  padding-bottom: 40px;
  background: var(--bg);
}

.backRow {
  padding: 20px 32px 0;
}
.backRow + header {
  padding-top: 8px;
}

.back {
  padding: 2px;
  font-size: 13.5px;
  color: var(--blue);
  background: none;
  border: none;
  cursor: pointer;
}

:global(html.dark) .back {
  color: var(--navy-accent);
}

/* ── Загрузка ── */
.uploadWrap {
  max-width: 620px;
  margin: 8px 32px 0;
}

.directLoad {
  margin-bottom: 20px;
}

.primaryButton {
  height: 40px;
  padding: 0 18px;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  background: var(--blue);
  border: none;
  border-radius: var(--r-sm);
  cursor: pointer;
}

.primaryButton:hover:not(:disabled) {
  background: var(--blue-dark);
}
.primaryButton:disabled {
  opacity: 0.6;
  cursor: default;
}

.directHint {
  margin-top: 8px;
  font-size: 13px;
  color: var(--text2);
}

.divider {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 20px;
  font-size: 13px;
  color: var(--text2);
}

.divider::after {
  content: '';
  flex: 1;
  border-top: 1px solid var(--border);
}

.dropzone {
  padding: 36px 24px;
  text-align: center;
  background: var(--card-bg);
  border: 1.5px dashed var(--border);
  border-radius: var(--r-lg);
  cursor: pointer;
  transition:
    border-color 0.15s,
    background 0.15s;
}

.dropzone:hover,
.dropzoneActive {
  border-color: var(--blue);
  background: var(--blue-lt);
}

.dropIcon {
  display: inline-flex;
  margin-bottom: 10px;
  color: var(--blue);
}
:global(html.dark) .dropIcon {
  color: var(--navy-accent);
}
.dropTitle {
  font-size: 16px;
  font-weight: 600;
  color: var(--text);
}
.dropHint {
  margin-top: 6px;
  font-size: 13.5px;
  line-height: 1.5;
  color: var(--text2);
}
.hiddenInput {
  display: none;
}

.error,
.messageOk {
  margin: 14px 0;
  padding: 10px 14px;
  font-size: 13.5px;
  border-radius: var(--r-sm);
}

.error {
  color: var(--err);
  background: var(--err-bg);
}
.messageOk {
  color: var(--ok);
  background: var(--ok-bg);
}

/* ── Разделы ── */
.section {
  padding: 0 32px 24px;
}

.sectionHeader {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px 12px;
  margin-bottom: 12px;
}

.sectionTitle {
  margin: 0 0 12px;
  font-size: 16px;
  font-weight: 600;
  color: var(--text);
}
.sectionHeader .sectionTitle {
  margin: 0;
}

.button {
  height: 34px;
  padding: 0 14px;
  margin-left: auto;
  font-size: 13.5px;
  font-weight: 500;
  color: var(--text);
  background: var(--card-bg);
  border: 1px solid var(--border);
  border-radius: var(--r-sm);
  cursor: pointer;
}

.button:hover:not(:disabled) {
  border-color: var(--slate-lt);
}
.button:disabled {
  opacity: 0.6;
  cursor: default;
}

.rowCount {
  padding: 0 7px;
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
  color: var(--text2);
  background: var(--border);
  border-radius: var(--r-pill);
}

/* ── Категории ── */
.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 12px;
}

.card {
  padding: 16px;
  text-align: left;
  background: var(--card-bg);
  border: 1px solid var(--border);
  border-radius: var(--r-md);
  cursor: pointer;
  transition: border-color 0.15s;
}

.card:hover {
  border-color: var(--blue);
}

.cardName {
  font-size: 14px;
  font-weight: 600;
  color: var(--text);
}
.cardRow {
  display: flex;
  align-items: baseline;
  gap: 10px;
  margin-top: 8px;
}
.cardCount {
  font-size: 24px;
  font-weight: 650;
  color: var(--text);
  font-variant-numeric: tabular-nums;
}
.cardIssues {
  font-size: 13px;
  color: var(--warn);
}
.cardOk {
  font-size: 13px;
  color: var(--ok);
}

/* ── Показатели сверки ── */
.kpiRow {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 10px;
}

.kpi {
  padding: 14px 16px;
  background: var(--card-bg);
  border: 1px solid var(--border);
  border-radius: var(--r-md);
}

.kpiValue {
  font-size: 24px;
  font-weight: 650;
  line-height: 1.1;
  color: var(--text);
  font-variant-numeric: tabular-nums;
}
.kpiLabel {
  margin-top: 4px;
  font-size: 13px;
  color: var(--text2);
}
.warn {
  color: var(--warn);
}

/* ── Таблица категории ── */
.toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  padding: 0 32px 12px;
}

.chip {
  height: 30px;
  padding: 0 12px;
  font-size: 13px;
  color: var(--text2);
  background: var(--card-bg);
  border: 1px solid var(--border);
  border-radius: var(--r-pill);
  cursor: pointer;
}

.chip:hover {
  color: var(--text);
  border-color: var(--slate-lt);
}

.chipOn,
.chipOn:hover {
  color: var(--blue);
  background: var(--blue-lt);
  border-color: color-mix(in srgb, var(--blue) 35%, transparent);
}

:global(html.dark) .chipOn {
  color: var(--navy-accent);
}

.search {
  width: 260px;
  margin-left: auto;
}

.tableWrap {
  overflow: auto;
  background: var(--card-bg);
  border: 1px solid var(--border);
  border-radius: var(--r-md);
}

.table {
  width: 100%;
  font-size: 13.5px;
  border-collapse: collapse;
}

.table th {
  position: sticky;
  top: 0;
  z-index: 1;
  padding: 10px 12px;
  font-size: 12.5px;
  font-weight: 600;
  color: var(--text2);
  text-align: left;
  white-space: nowrap;
  background: var(--card-bg);
  box-shadow: inset 0 -1px 0 var(--border);
}

.table th:has(.sortButton) {
  padding: 0;
}

.sortButton {
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
  padding: 10px 12px;
  font: inherit;
  color: inherit;
  text-align: left;
  background: none;
  border: none;
  cursor: pointer;
}

.sortButton:hover {
  color: var(--text);
}
.sortMark {
  min-width: 10px;
  color: var(--blue);
}

.table td {
  padding: 10px 12px;
  color: var(--text);
  border-bottom: 1px solid var(--border);
}

.table tbody tr:last-child td {
  border-bottom: none;
}
.rowIssue td:first-child {
  box-shadow: inset 3px 0 0 var(--led-open);
}

.issueText {
  color: var(--err);
}
.mono {
  font-family: var(--mono);
  font-size: 12.5px;
}
.muted {
  color: var(--slate-lt);
}

.empty {
  padding: 40px 20px;
  font-size: 14px;
  color: var(--text2);
  text-align: center;
}

@media (max-width: 699px) {
  .backRow {
    padding: 14px 16px 0;
  }
  .uploadWrap {
    margin: 8px 16px 0;
  }
  .section {
    padding: 0 16px 20px;
  }
  .toolbar {
    padding: 0 16px 12px;
  }
  .search {
    width: 100%;
    margin-left: 0;
  }
}
